<template>
  <div>
    <div class="search-wrapper">
      <div class="search-item">
        <span>流水号：</span>
        <Input style="width:200px;" v-model="searchValue.flowNum"></Input>
      </div>
      <div class="search-item">
        <span>流程名称：</span>
        <Input style="width:200px;" v-model="searchValue.flowName"></Input>
      </div>
      <div class="search-item">
        <span>申请人：</span>
        <Input style="width:200px;" v-model="searchValue.creator"></Input>
      </div>
      <Button type="primary" @click="getToDoListData">搜索</Button>
      <slot name="extraBtn"></slot>
    </div>
    <Table :columns="columns" :data="flowList" style="min-width:1200px;"></Table>
    <Page style="margin-top:5px;" :total="total" show-elevator :current="currentPage" @on-change="getToDoListData"></Page>
    <!-- 档案调阅申请表 -->
    <Modal v-model="showReserchForm" title="档案调阅申请表" width="680">
      <research-form ref="form" :formInfo="formInfo"></research-form>
      <div slot="footer" style="text-align:center">
        <Button @click="rejectFlow(flowItemDetail)" type="error" :disabled="flowItemDetail.ActivityName==='发起人'">退回</Button>
        <Button @click="approvalFlowNext(flowItemDetail)" type="primary">流转</Button>
      </div>
    </Modal>
    <!-- 流程记录 -->
    <Modal v-model="showHistory" title="流程记录" width="600">
      <Table :columns="flowColumns" :data="flowData"></Table>
      <div slot="footer"></div>
    </Modal>
    <!-- 流程审批选择 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="(e)=>{branchVisible=e}"
      @branchChoose="branchChoose"
      :branchType="branchType"
      ref="flowBranch"
    ></flowBranch>
    <!-- 流程人员选择 -->
    <Modal
      v-model="peopleSelectVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="(e)=>{selectedPeople=e}"
      ></flowNext>
      <div slot="footer">
        <Button @click="peopleSelectVisible=false">取消</Button>
        <Button
          @click="nextFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { getFlowHistory, getToDoList, getActivityUsers, deliverFlow, getRejectActivityUsers, endFlow, rejectFlow } from '@/lib/flow'
import { formatDate } from '@/lib/tool'
import FlowBranch from '@/components/flow/flowBranch'
import FlowNext from '@/components/flow/flowNext'
import researchForm from './researchForm'

export default {
  components: {
    FlowBranch,
    FlowNext,
    researchForm
  },
  data() {
    return {
      searchValue: {
        flowNum: '',
        flowName: '',
        creator: ''
      },
      flowList: [],
      columns: [
        {
          title: '流水号',
          key: 'SheetId',
          width: 120
        },
        {
          title: '流程名称',
          key: 'WorkflowTitle'
        },
        {
          title: '申请人',
          key: 'CreatorRealName',
          width: 85
        },
        {
          title: '申请日期',
          width: 108,
          render: (h, params) => {
            let data = parseInt(params.row.CreatedTime.replace('/Date(', '').replace(')/', ''))
            return h('div', formatDate(data).slice(0, 10))
          }
        },
        {
          title: '是否归还',
          key: 'BusinessKey',
          width: 90,
          render: (h, params) => {
            let BusinessKey = JSON.parse(params.row.BusinessKey)
            return h('div', BusinessKey.isReturn)
          }
        },
        {
          title: '预计归还时间',
          key: 'BusinessKey',
          width: 108,
          align: 'center',
          render: (h, params) => {
            let BusinessKey = JSON.parse(params.row.BusinessKey)
            return h('div', BusinessKey.isReturn === '是' ? BusinessKey.remark.slice(0,10) : '/')
          }
        },
        {
          title: '不归还原因',
          key: 'BusinessKey',
          width: 108,
          align: 'center',
          render: (h, params) => {
            let BusinessKey = JSON.parse(params.row.BusinessKey)
            return h('div', BusinessKey.isReturn === '否' ? BusinessKey.remark : '/')
          }
        },
        {
          title: '流程状态',
          key: 'WorkflowInstanceState',
          align: 'center',
          width: 108,
          render: (h, params) => {
            switch (params.row.WorkflowInstanceState) {
              case 3:
                return h('div', '成功')
                break
              case 5:
                return h('div', '驳回')
                break
              case 2:
                return h('div', '审批中')
                break
            }
          }
        },
        {
          title: '操作',
          key: "Actions",
          align: 'center',
          width: 240,
          render: (h, params) => {
            let disabled = true
            if (this.flowStatus === 1) {
              disabled = false
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.flowItemDetail = params.row
                    this.approvalFlowNext(params.row)
                  }
                }
              }, '流转'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.ActivityName === '发起人'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.flowItemDetail = params.row
                    this.rejectFlow(params)
                  }
                }
              }, '退回'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.flowItemDetail = params.row
                    this.$Spin.show()
                    // 获取申请表内容
                    ajax.get(requestUrls.CLShiftingFile.GetPaged, {
                      params: {
                        filter: `flowId == "${params.row.WorkflowInstanceId}"`
                      }
                    }).then(res => {
                      this.$Spin.hide()
                      this.formInfo = Object.assign(res.data.result.items[0], {
                        sheetId: params.row.ActivityName === '提单' ? '' : params.row.SheetId,
                        state: params.row.WorkflowInstanceState
                      })
                      this.showReserchForm = true
                    })
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: async () => {
                    this.flowItemDetail = params.row
                    this.showHistory = true
                    // 获取流程详情
                    try {
                      let rep = await getFlowHistory(this.userInfo.phoneNumber, params.row.WorkflowInstanceId)
                      this.flowData = rep
                    } catch (err) {
                      console.error(err)
                      this.flowData = []
                    }
                  }
                }
              }, '流程记录')
            ]);
          }
        }
      ],
      currentPage: 1,
      total: 0,
      argumentTypes: [],
      searchValue: {
        area: '',
        argumentName: '',
        argumentType: ''
      },
      districts: [],
      showHistory: false,
      flowColumns: [
        {
          title: '操作类型',
          key: 'ActivityShowName'
        },
        {
          title: '操作人',
          key: 'RealName',
        },
        {
          title: '执行结果',
          render: (h, params) => {
            let result = '-'
            let resultColor = ''
            switch (params.row.CompletedType) {
              case 'StartWorkflow':
                resultColor = '#19be6b'
                result = '发起'
                break
              case 'Approval':
                resultColor = '#19be6b'
                result = '通过'
                break
              case 'Reject':
                resultColor = '#ed3f14'
                result = '驳回'
                break
              case '':
                resultColor = '#ff9900'
                result = '待办'
                break
            }
            let style = {
              backgroundColor: resultColor,
              borderRadius: '50%',
              width: '6px',
              height: '6px',
              display: 'inline-block',
              marginRight: '5px'
            }
            return (
              <div>
                <div style={style}></div>
                <span>{result}</span>
              </div>
            )
          }
        },
        {
          title: '操作时间',
          width: 105,
          render: (h, params) => {
            let time = ''
            if (params.row.CompletedTime) {
              time = parseInt(params.row.CompletedTime.slice(6, 19))
              time = formatDate(time).split(' ')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '备注',
          key: 'Opinion'
        }
      ],
      flowData: [],
      branchVisible: false,
      peopleSelectVisible: false,
      flowBranch: {},
      selectedPeople: {},
      flowItemDetail: {},
      flowBranch: [],
      branchType: 'next',
      flowPeople: '',
      showReserchForm: false,
      formInfo: {}
    }
  },
  created() {
    this.getToDoListData()
    // this.getDistrict()
  },
  computed: {
    userInfo () {
      return this.$store.state.session.user
    }
  },
  methods: {
    // 获取代办数据
    async getToDoListData(page = 1) {
      this.currentPage = page
      let query = `AppId='DY'`
      let searchNum = this.searchValue.flowNum ? ` and SheetId like'%${this.searchValue.flowNum}%'` : ''
      let searchName = this.searchValue.flowName ? ` and WorkflowTitle like'%${this.searchValue.flowName}%'` : ''
      // `AppId='${this.type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
      let rep = await getToDoList(this.userInfo.phoneNumber, { page: page, size: 10, whereStr: `AppId='DY'` })
      this.flowList = rep.rows
      this.total = rep.total
    },
    // async getDistrict() {
    //   let rep = await ajax(requestUrls.CLDistrict.GetListWithoutRole)
    //   this.districts = []
    //   if (rep.data.success) {
    //     this.districts = rep.data.result.items
    //   }
    // },
    branchChoose(val) {
      this.flowPeople = val
      if (this.branchType === 'next' || this.branchType === 'start') {
        this.peopleSelectVisible = true
      }
      if (this.branchType === 'reject') {
        if (this.$refs.flowBranch.opinion === '' || !this.$refs.flowBranch.opinion) {
          this.$Message.info('请填写退回原因')
          return
        }
        this.rejectFlowConfirm()
      }
      this.branchVisible = false
    },
    async approvalFlowNext(param) {
      this.$Spin.show()
      // 获取流程人员
      let processVariablesJson = JSON.stringify([{ key: 'isReturn', value: param.BusinessKey }])
      try {
        let rep = await getActivityUsers({ appId: 'DY', userPhone: this.userInfo.phoneNumber, taskId: param.TaskId, processVariablesJson: processVariablesJson })
        this.$Spin.hide()
        this.branchType = 'next'
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('流程人员获取失败')
      }
    },
    async nextFlow() {
      this.$Spin.show()
      this.branchType = 'next'
      let opinion = this.$refs.flowBranch.opinion
      if (this.flowPeople.NextActivityName !== '结束') {
        if (!this.selectedPeople.userId) {
          this.$Spin.hide()
          this.$Message.error('请选择流程人员')
          return
        }
        // 流程转交
        try {
          let rep = await deliverFlow(this.userInfo.phoneNumber, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, userId: this.selectedPeople.userId, opinion: opinion })
          this.$Spin.hide()
          this.$Message.success('已流转至下一审核人')
          this.selectedPeople = {}
          this.getToDoListData()
          this.peopleSelectVisible = false
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程转交失败')
        }
      } else {
        // 结束流程
        try {
          let rep = await endFlow(this.userInfo.phoneNumber, { taskId: this.flowItemDetail.TaskId, nextActivityCode: this.flowPeople.NextActivityCode, opinion: opinion })
          if (!this.isNormal) {
            this.$Spin.hide()
            this.$Message.success('流程结束成功')
            this.peopleSelectVisible = false
            this.getToDoListData()
            return
          }
          // 创建退保订单
          const depositRefundData = this.$refs.refundData.depositRefundData
          
          let refundList = []
          depositRefundData.forEach(refundItem => {
            const x2Json = new x2js()
            const xmlJSON = x2Json.xml2js(refundItem.content)
            refundList.push({
              amount: refundItem.orders.orderAmountTotal,
              refundOA: this.flowItemDetail.SheetId,
              orderMethod: refundItem.orders.payChannel,
              numberDay: '',
              OrderPayTime: formatDate(),
              comment: '',
              cause: '',
              accountName: refundItem.orders.abpOrdersExp.bankName,
              bankAccount: refundItem.orders.abpOrdersExp.bankAccount,
              marginDetailId: refundItem.orders.clMarginId,
              orderNo: xmlJSON.root.orderNo,
              orderConfirm: this.user.name,
              ordersExp: {
                bankName: refundItem.orders.abpOrdersExp.bankName,
                bankAccount: refundItem.orders.abpOrdersExp.bankAccount,
                projectId: refundItem.projectId,
                groupId: refundItem.orders.abpOrdersExp.groupId,
                groupName: refundItem.orders.abpOrdersExp.groupName
              }
            })
          })
          await ajax.post(requestUrls.order.CreateRefundList, refundList)

          this.$Spin.hide()
          this.$Message.success('流程结束成功')
          this.peopleSelectVisible = false
          this.showReserchForm = false
          this.getToDoListData()
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程结束失败')
        }
      }
    },
    async rejectFlowConfirm() {
      this.$Spin.show()
      try {
        let rep = await rejectFlow(this.userInfo.phoneNumber, { taskId: this.flowItemDetail.TaskId, activityCode: this.flowPeople.ActivityCode, opinion: this.$refs.flowBranch.opinion })
        this.$Message.success('退回操作成功')
        this.selectedPeople = {}
        this.showReserchForm = false
        this.$Spin.hide()
        // 刷新表格
        this.getToDoListData()
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回操作失败')
      }
    },
    async rejectFlow() {
      // 获取流程人员
      this.$Spin.show()
      try {
        let rep = await getRejectActivityUsers(this.userInfo.phoneNumber, this.flowItemDetail.TaskId)
        this.$Spin.hide()
        if (rep.length > 0) {
          this.branchType = 'reject'
          this.flowBranch = rep
          this.branchVisible = true
        } else {
          this.$Message.info('发起人无法退回')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回流程获取失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  .search-item {
    margin-right: 10px;
  }
}
</style>
